import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import {getPriceText} from "../../../../util/commonFunctions";
import React from "react";
import {Price} from "../../../../types/cart";
import {useTranslation} from "react-i18next";

interface Args{
    totalPrice: Price;
    totalDiscountAmount: number;
    selectedCouponIdx: number | null;
    codeDiscountAmount: number;
    isGirdField?: boolean
}
export function OrderSummaryField(
    {totalPrice, totalDiscountAmount, selectedCouponIdx, codeDiscountAmount, isGirdField}: Args) {
    const { t } = useTranslation("order");

    return (
        <div className={`${style.orderedAmountInfo} ${isGirdField && style.grid}`}>
            <h3 className={style.sectionTitle}>{t("summary.title")}</h3>
            <div className={style.amountDetail}>
                <ul className={style.amountList}>
                    <li className={style.amountItem}>
                        <span>{t("summary.totalProductPrice")}</span>
                        <span>{getPriceText(totalPrice.regularAmount)}{t("summary.unit")}</span>
                    </li>
                    {totalDiscountAmount > 0 && (
                        <li className={`${style.amountItem} ${style.accent}`}>
                            <span>{t("summary.salePrice")}</span>
                            <span>-{getPriceText(totalDiscountAmount)}{t("summary.unit")}</span>
                        </li>
                    )}
                    {totalPrice.productDiscountAmount > 0 && (
                        <li className={style.amountItem}>
                            <span>{t("summary.productDiscountAmount")}</span>
                            <span>-{getPriceText(totalPrice.productDiscountAmountShown)}{t("summary.unit")}</span>
                        </li>
                    )}
                    {selectedCouponIdx ? (
                        <li className={style.amountItem}>
                            <span>{t("summary.couponDiscountAmount")}</span>
                            <span>-{getPriceText(totalPrice.couponDiscountAmountShown)}{t("summary.unit")}</span>
                        </li>
                    ) : (
                        <></>
                    )}
                    {codeDiscountAmount !== 0 ? (
                        <li className={style.amountItem}>
                            <span>{t("summary.codeDiscountAmount")}</span>
                            <span>-{getPriceText(codeDiscountAmount)}{t("summary.unit")}</span>
                        </li>
                    ) : (
                        <></>
                    )}
                </ul>
                <div className={style.totalAmount}>
                    <span>{t("summary.totalOrderPrice")}</span>
                    <span>{getPriceText(totalPrice.actualAmountShown)}{t("summary.unit")}</span>
                </div>
            </div>
        </div>
    );
}